import LazyLoad from "vanilla-lazyload";

var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy-load"
});
